// @flow
// Shared robot SVG markup used across tooltip, autocomplete, and server-side helpers.
// The canonical React component is AgentBadge/index.jsx — use it when rendering in React.
// This module provides raw SVG strings for non-React contexts (D3 tooltips, jQuery).

type RobotSvgOpts = {
  bodyColor?: string,
  accentColor?: string,
  width?: number | string,
  height?: number | string,
  ...
}

const robotSvg = ({
  bodyColor = '#fff',
  accentColor = 'var(--agent-avatar-bg)',
  width = 11,
  height = 13,
}: RobotSvgOpts = {}): string => (
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 28" fill="none" width="${width}" height="${height}">`
  + `<line x1="12" y1="2" x2="12" y2="5" stroke="${bodyColor}" stroke-width="1.5" stroke-linecap="round"/>`
  + `<circle cx="12" cy="1.5" r="1.5" fill="${bodyColor}"/>`
  + `<rect x="4" y="5" width="16" height="16" rx="3" fill="${bodyColor}"/>`
  + `<circle cx="9" cy="12.5" r="2" fill="${accentColor}"/>`
  + `<circle cx="15" cy="12.5" r="2" fill="${accentColor}"/>`
  + `<path d="M9 17 Q12 19 15 17" stroke="${accentColor}" stroke-width="1.2" stroke-linecap="round" fill="none"/>`
  + `<rect x="1" y="10.5" width="2.5" height="5" rx="1" fill="${bodyColor}"/>`
  + `<rect x="20.5" y="10.5" width="2.5" height="5" rx="1" fill="${bodyColor}"/>`
  + '</svg>'
)

export default robotSvg
